// Reading a sheet someone filled in. The run itself answers in JSON, so this is only for a file
// off disk.

// RFC 4180: fields may be quoted, and a quoted field may hold commas, newlines and "" escapes.
export function parseCsv(text) {
    const rows = []
    let row = []
    let field = ''
    let quoted = false
    let started = false

    const endField = () => { row.push(field); field = ''; started = false }
    const endRow = () => { endField(); rows.push(row); row = [] }

    for (let i = 0; i < text.length; i++) {
        const char = text[i]
        if (quoted) {
            if (char !== '"') { field += char; continue }
            if (text[i + 1] === '"') { field += '"'; i++; continue }
            quoted = false
            continue
        }
        if (char === '"' && !started) { quoted = true; started = true; continue }
        if (char === ',') { endField(); continue }
        if (char === '\r') continue
        if (char === '\n') { endRow(); continue }
        field += char
        started = true
    }
    // A file ending in a newline has no trailing row.
    if (field !== '' || started || row.length) endRow()

    const columns = rows.shift() || []
    return {
        columns,
        rows: rows
            .filter(cells => cells.some(cell => cell !== ''))
            .map(cells => Object.fromEntries(columns.map((name, i) => [name, cells[i] ?? '']))),
    }
}
